import { z } from 'zod';
import { DEFAULT_PIN_THEME_ID } from '../../defaults';
import { LayoutPartSchema, PinComponentSchema } from '../pin-component';

export const ExclusionTypeSchema = z.enum(['realtime', 'homework']);
export type ExclusionType = z.infer<typeof ExclusionTypeSchema>;

// TODO: Probably duplicated somewhere, should be uppercase but it's also used in old lesson as lowercase
export const DiffCustomEntryLabels = z.enum(['custom-1', 'custom-2', 'custom-3', 'custom-4', 'custom-5', 'custom-6']);
export const DiffNoPickedLabels = z.enum(['none-1', 'none-2', 'none-3', 'none-4', 'none-5', 'none-6']);
export const DiffLabel = z.enum(['-', '+', '0']).or(DiffCustomEntryLabels).or(DiffNoPickedLabels);

export const BasePinThemeSettingsSchema = z.object({
  backgroundColor: z.string().min(1).optional(),
  backgroundImage: z.string().min(1).optional(),
  backgroundTransparency: z.number().optional(),
});
export type BasePinThemeSettings = z.infer<typeof BasePinThemeSettingsSchema>;

export const BasePinSettingsSchema = BasePinThemeSettingsSchema.extend(
  z.object({
    testPoints: z.number().optional(), // TODO move to (quiz, openquestion, dragquestion) slide settings, resulted in a bunch of errors because we don't have good typeguarding inside our v1 to v2 mappers
    timer: z.number().optional(), // TODO move to (quiz, openquestion, wordCloud) slide settings, resulted in a bunch of errors because we don't have good typeguarding inside our v1 to v2 mappers
    differentiation: DiffLabel.optional(),
    pinThemeId: z
      .string()
      .optional()
      .refine((val) => val !== DEFAULT_PIN_THEME_ID, {
        message: 'pinThemeId should not be the same as default PinTheme id',
      }),
  }).shape
);

export const BasePinSchema = z.object({
  createdAt: z.string(),
  id: z.string().min(1),
  v1Pin: z.string().min(1).optional(),
  order: z.string(),
  pinComponents: z.array(PinComponentSchema),
  updatedAt: z.string(),
  exclusions: z.array(ExclusionTypeSchema).optional(),
  parentPinId: z.string().optional(), // if this is filled with a pin_id, the pin is a sub-pin on the interactive video question
  source: z.string().optional(),
  settings: BasePinSettingsSchema.extend(
    z.object({
      layout: z.string().min(1).optional(), // TODO: Code depends on all types to have a layout
    }).shape
  ),
  // // TODO ED-542  Commented until we are going to refactor the assignments backend / should be removed
  // item: z.object({
  // custom: z.any().optional(), // Differs per pin type. Everything in custom will move to settings.
  // components: z.any().optional(), // Component.All[], // renamed to pinComponents on the root, the types are / will be rewritten
  // url: z.string().optional(), // used by multiple pin types, should be moved to settings of specific pin types
  // uploadId: z.string().optional(), // we will remove this, wasn't filled consistently
  // exclusions: z.any().optional(), // was ExclusionType[]. 'realtime', 'homework'. can be moved to the pin root
  // shuffleMap: z.any().optional(), // quiz only, shuffling answers (assessment (test) only) -> teacherSettings

  // videoItems: z.any().optional(), // for interactive video Video.VideoItems[] , undefined, // video settings
  // notes: z.any().optional(), // Note, // teacherSettings for every pin (is there some base object or this?)

  // }),

  // videoQuestion: z.string().optional(), // if this is filled with a pin_id, the pin is a sub-pin on the interactive video question. Change to field name to parentPinId?
  // differentiation: z.any(), // same as diff. move to settings
});
export type BasePin = z.infer<typeof BasePinSchema>;

export const BaseInteractiveQuestionPinSettingsSchema = BasePinSettingsSchema.extend(
  z.object({
    questionId: z.string().nullish(), // TODO: Should be required, nullish until data migration or make required and purge data
  }).shape
);

export type BaseInteractiveQuestionPinSettings = z.infer<typeof BaseInteractiveQuestionPinSettingsSchema>;

export const BaseStyleSchema = z.object({
  fontFamily: z.string().min(1).optional(),
  fontSize: z.string().min(1).optional(),
});

export const BaseTemplateLayoutSchema = z.object({
  pinComponents: z.array(PinComponentSchema),
  backgroundColor: z.string().optional(),
  backgroundImage: z.string().optional(),
  backgroundTransparency: z.number().optional(),
  layoutParts: z.partialRecord(LayoutPartSchema, PinComponentSchema.optional()), // TODO: Can this be removed from the base without issues?
});

export type BaseTemplateLayout = z.infer<typeof BaseTemplateLayoutSchema>;
